/**
 * Importação da biblioteca axios para fazer requisições baseadas em Promises.
 */
import axios from 'axios';

export default class WFS {
  static async getFeature(url) {
    return axios(`${url}`);
  }
}
